import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TestimonialService } from '../../_services/testimonial.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-testimonials-page',
    templateUrl: './testimonials-page.component.html',
    styleUrls: ['./testimonials-page.component.css'],
    standalone: false
})
export class TestimonialsPageComponent implements OnInit {
    testimonials = [];
    loading = true;
    apiUrl = environment.apiUrl;

    constructor(
        private titleService: Title,
        private testimonialService: TestimonialService,
        private translateService: TranslateService
    ) { }

    ngOnInit() {
        this.translateService.get('common.testimonials').subscribe(value => {
            this.titleService.setTitle(value);
        });
        this.loadTestimonials();
        window.scrollTo(0, 0);
    }

    loadTestimonials() {
        this.testimonialService.loadAll().subscribe({
            next: (response: any) => {
                const items = response.data || response || [];
                this.testimonials = items.map((item: any) => ({
                    id: item.id,
                    author: item.displayName,
                    role: `${item.jobTitle}, ${item.company}`,
                    comment: item.comment,
                    photo: item.profilePhotoPath ? `${this.apiUrl}/${item.profilePhotoPath}` : '',
                    location: item.location
                }));
                this.loading = false;
            },
            error: () => {
                this.testimonials = [];
                this.loading = false;
            }
        });
    }
}
